export default __webpack_public_path__ + "static/media/monsoon.27bdf77d.jpg";